/*
  Create Your Piece — font selector (10.06: "the five live specimens").
  Each tile sets the customer's own text in its face. A radio group; every
  font is included, and a font change never touches the text.
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  CYP.use(function (cyp) {
    var box = cyp.root.querySelector('[data-font-tiles]');
    if (!box) return;
    var tiles = box.querySelectorAll('[data-font]');

    function render() {
      var s = cyp.state;
      var text = (s.value || '').trim() || 'Aa';
      tiles.forEach(function (tile) {
        var input = tile.querySelector('input');
        input.checked = input.value === s.font;
        tile.classList.toggle('is-selected', input.checked);
        var spec = tile.querySelector('[data-font-spec]');
        if (spec.textContent !== text) spec.textContent = text;
        spec.classList.toggle('is-long', text.length > 4);
      });
    }

    box.addEventListener('change', function (e) {
      if (e.target.name !== 'pb-font') return;
      cyp.set({ font: e.target.value });
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.name === 'pb-font') {
        e.preventDefault();
        var next = cyp.root.querySelector('[data-text-next]');
        if (next) next.click();
      }
    });

    cyp.on('state', render);
  });
})();
